import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { isPresent } from 'helpers/string_helpers';

import FilterButton from 'components/ui/filter_button';
import SaleFilterGroup from 'components/research_property/sale_filter_group';
import LeaseFilterGroup from 'components/research_property/lease_filter_group';

import {
  clearFilters,
  clearFiltersIfEmpty,
  changeLeaseFilterGroup,
  changeSaleFilterGroup
} from '../store/actions/query';
import { delayRetrieveRecords } from '../store/actions/search';

export class CompsSaleOrLeaseFilterGroup extends React.Component {

  static propTypes = {
    clearFiltersIfEmpty: PropTypes.func.isRequired,
    currentTab: PropTypes.string.isRequired,
    delayRetrieveRecords: PropTypes.func,
    leaseFilter: PropTypes.object.isRequired,
    leaseSpaceTypeMappings: PropTypes.array.isRequired,
    leaseTypeMappings: PropTypes.array.isRequired,
    leaseUnits: PropTypes.array.isRequired,
    saleFilter: PropTypes.object.isRequired,

    onChangeLeaseFilterGroup: PropTypes.func.isRequired,
    onChangeSaleFilterGroup: PropTypes.func.isRequired,
    onClearFilters: PropTypes.func.isRequired
  };

  handleRetrieveRecords = () => {
    const { clearFiltersIfEmpty, delayRetrieveRecords } = this.props;
    clearFiltersIfEmpty();
    delayRetrieveRecords();
  }

  handleSaleFilterChange = (value, name) => {
    const { saleFilter, onChangeSaleFilterGroup } = this.props;
    if (value && value.target) {
      value = value.target.value;
    }

    value = value || '';

    saleFilter[name] = value;
    onChangeSaleFilterGroup(saleFilter);
    this.handleRetrieveRecords();
  };

  handleLeaseFilterChange = (value, name) => {
    const { leaseFilter, onChangeLeaseFilterGroup } = this.props;
    if (value && value.target) {
      value = value.target.value;
    }

    value = value || '';

    leaseFilter[name] = value;
    onChangeLeaseFilterGroup(leaseFilter);
    this.handleRetrieveRecords();
  };

  renderSaleOrLeaseFilters() {
    const {
      currentTab,
      leaseUnits,
      leaseSpaceTypeMappings,
      leaseTypeMappings,
      leaseFilter,
      saleFilter
    } = this.props;

    if (currentTab == 'lease') {
      return (
        <LeaseFilterGroup
          leaseFilter={leaseFilter}
          leaseSpaceTypeMappings={leaseSpaceTypeMappings}
          leaseTypeMappings={leaseTypeMappings}
          leaseUnits={leaseUnits}
          onFilterChange={this.handleLeaseFilterChange}
        />
      );
    } else {
      return (
        <SaleFilterGroup
          saleFilter={saleFilter}
          onFilterChange={this.handleSaleFilterChange}
        />
      );
    }
  }

  render() {
    const { currentTab, leaseFilter, saleFilter } = this.props;

    const saleFiltersApplied = Object.keys(saleFilter).some((k) => {
      return isPresent(saleFilter[k]);
    });

    const leaseFiltersApplied = Object.keys(leaseFilter).some((k) => {
      return (isPresent(leaseFilter[k]) && k !== 'leaseRateUnits');
    });

    return (
      <FilterButton
        filtersApplied={currentTab == 'lease' ? leaseFiltersApplied : saleFiltersApplied}
        label={currentTab == 'lease' ? 'Lease Details' : 'Sale Details'}
        name="sale-lease"
      >
        {this.renderSaleOrLeaseFilters()}
      </FilterButton>
    );
  }
}


const mapStateToProps = state => ({
  ...state.static,
  currentTab: state.ui.currentTab,
  leaseFilter: state.query.leaseFilter,
  saleFilter: state.query.saleFilter,
});

const mapDispatchToProps = {
  clearFiltersIfEmpty,
  delayRetrieveRecords,

  onClearFilters: clearFilters,
  onChangeLeaseFilterGroup: changeLeaseFilterGroup,
  onChangeSaleFilterGroup: changeSaleFilterGroup,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompsSaleOrLeaseFilterGroup);
